import React, { Fragment } from 'react'
import useLayout from './useLayout'
import clsx from 'clsx'
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import CssBaseline from '@material-ui/core/CssBaseline'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { Link } from 'react-router-dom'
import { lstPrivateRoutes, RoutePath, RoutesType } from '../../../router/routesConfig'
import { LayoutViewProps } from './layoutType'
import MenuOpenIcon from '@material-ui/icons/MenuOpen'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import useTranslate from '../../../i18n/useTranslate'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import { ClickAwayListener, Grid, Grow, ListSubheader, MenuItem, MenuList, Paper, Popper } from '@material-ui/core'
import { Redirect, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import Badge from '@material-ui/core/Badge'
import BellIcon from '@material-ui/icons/Notifications'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'

import useAuthenService from '../../../services/authen/useAuthenService'
import authenAction from '../../../stores/authen/authenAction'
import useAuthenStore from '../../../stores/authen/authenStore'
import LogoutBTN from './logout'

import TabManager from '../manageProject/tabManager/tabManager'
import Language from './language/language'
import Notification from './notification/notification'
import UserManualDoc from './userManualDoc/userManualDoc'
import SopDoc from './sopDoc/sopDoc'
import RenderMenu from './RenderMenu'
import { env } from 'process'
const drawerWidth = 240

type MatchParams = {
    id: string
}

const StyledBadge = withStyles((theme) => ({
    badge: {
        right: -3,
        top: 13,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}))(Badge)

const LayoutView: React.FC<LayoutViewProps & ReturnType<typeof useLayout>> = ({
    children,
    open,
    selectedMenu,
    // tabIndex,
    // onChangeTab,
    handleTogleSidebar,
    handleSelectedMenu,
    handleClickProfile,
}) => {
    const authenService = useAuthenService()
    const autAction = authenAction()
    const authenStore = useAuthenStore()

    const translate = useTranslate()

    const history = useHistory()
    let location = useLocation()
    const matchEdit = useRouteMatch<MatchParams>(RoutePath.manageProjectEdit)
    const isEditpage = matchEdit?.path === RoutePath.manageProjectEdit
    const isCreatepage = location.pathname === RoutePath.manageProjectCreateRequest

    const isShowTab = isEditpage || isCreatepage

    const classes = useStyles({ isShowTab })
    const theme = useTheme()
    // const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'))

    const getDisplayNameUser = () => {
        const NO_NAME = '???? ????'
        let name = NO_NAME

        if (translate.languageStore.currentLanguage === translate.languageKey.th) {
            name = authenStore.profile?.name_th ?? NO_NAME
        } else {
            name = authenStore.profile?.name_en ?? NO_NAME
        }
        return name
    }
    const getDisplayUserGroup = () => {
        const NO_NAME = '???? ????'
        let name = NO_NAME

        if (translate.languageStore.currentLanguage === translate.languageKey.th) {
            name = authenStore.profile?.userGroupName_th ?? NO_NAME
        } else {
            name = authenStore.profile?.userGroupName_en ?? NO_NAME
        }
        return name
    }

    return (
        <>
            <div className={classes.root}>
                <CssBaseline />
                <AppBar
                    position="fixed"
                    className={
                        isMobileView
                            ? classes.appBar
                            : clsx(classes.appBar, {
                                  [classes.appBarShift]: open,
                              })
                    }
                >
                    <Toolbar>
                        <Grid container justify="space-between" alignContent="center">
                            <Grid item xs={false}>
                                <Grid container alignContent="center" justify="flex-start" style={{ height: '100%' }}>
                                    <Grid item xs={'auto'}>
                                        <IconButton
                                            // color="primary"
                                            aria-label="open drawer"
                                            onClick={handleTogleSidebar}
                                            edge="start"
                                            className={clsx(classes.menuButton)}
                                        >
                                            <MenuOpenIcon color={'action'} style={{ fontSize: '25px' }} />
                                        </IconButton>
                                    </Grid>
                                    <Grid item className={classes.itemRole}>
                                        <Grid container alignContent="center" style={{ height: '100%' }}>
                                            <div>
                                                <Typography
                                                    noWrap
                                                    variant={'body2'}
                                                    className={clsx(classes.textPrimary)}
                                                >
                                                    {getDisplayUserGroup()}
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs="auto">
                                <Grid
                                    container
                                    item
                                    xs={true}
                                    style={{
                                        textAlign: 'end',
                                        minWidth: !isMobileView ? '350px' : '0px',
                                        height: '100%',
                                    }}
                                    alignContent="center"
                                >
                                    <Grid container item xs alignContent="center" justify="flex-end">
                                        <Grid item xs={false}>
                                            <Language />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={false}
                                            style={{
                                                textAlign: 'center',
                                                marginRight: '25px',
                                                marginLeft: '8px',
                                            }}
                                        >
                                            <Grid container alignContent="center">
                                                <Notification />
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={false}
                                            style={{
                                                textAlign: 'center',
                                                marginRight: '8px',
                                                marginLeft: '-8px',
                                            }}
                                        >
                                            <Grid container alignContent="center">
                                                <UserManualDoc />
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={false}
                                            style={{
                                                textAlign: 'center',
                                                marginRight: '8px',
                                                marginLeft: '-8px',
                                            }}
                                        >
                                            <Grid container alignContent="center">
                                                <SopDoc />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={false} style={{ color: 'black' }}>
                                            <Grid container alignContent="center">
                                                <Avatar
                                                    alt={`${authenStore.profile.name_en}`}
                                                    src={
                                                        authenStore.profile?.image_path &&
                                                        authenStore.profile?.image_path !== ''
                                                            ? `${process.env.REACT_APP_UPLOAD}${authenStore.profile.image_path}`
                                                            : ''
                                                    }
                                                    onClick={handleClickProfile}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            </Grid>
                                        </Grid>
                                        {!isMobileView && (
                                            <Grid item xs={false}>
                                                <Grid container alignContent="center" style={{ height: '100%' }}>
                                                    <div style={{ padding: '0px 15px' }}>
                                                        <Typography
                                                            noWrap
                                                            variant={'body2'}
                                                            className={clsx(classes.textPrimary)}
                                                        >
                                                            {getDisplayNameUser()}
                                                        </Typography>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Grid>
                                    <Grid item xs={false}>
                                        <Grid
                                            container
                                            alignContent="center"
                                            style={{ height: '100%', marginLeft: isMobileView ? '8px' : '0px' }}
                                        >
                                            <LogoutBTN />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Toolbar>

                    {/* <Tabs
                            value={0}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={() => {}}
                            aria-label="disabled tabs example"
                        >
                            <Tab label="Active" />
                            <Tab label="Disabled" disabled />
                            <Tab label="Active" />
                        </Tabs> */}
                    {isShowTab && <TabManager />}
                    {/* {isShowTab && <MyTabs onChangeTab={onChangeTab} tabIndex={tabIndex} />} */}
                </AppBar>
                <Drawer
                    className={classes.drawer}
                    variant={isMobileView ? 'temporary' : 'persistent'}
                    anchor="left"
                    open={open}
                    onClose={handleTogleSidebar}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >
                    <div>
                        <img
                            src={process.env.PUBLIC_URL + '/img/Chulalongkorn_University_Alt_Logo.svg.png'}
                            alt="chula"
                            style={{ width: '70% ', verticalAlign: 'middle', margin: 20 }}
                        />
                    </div>

                    <Divider />
                    <div style={{ height: 'calc(100% - 140px)', overflowY: 'auto' }}>
                        {lstPrivateRoutes.map((route, index) => (
                            <RenderMenu
                                route={route}
                                index={index}
                                key={route.menuID}
                                selectedMenu={selectedMenu}
                                handleSelectedMenu={handleSelectedMenu}
                            />
                        ))}
                    </div>
                    <div style={{ height: '40px', lineHeight: '40px', textAlign: 'center', fontSize: '12px' }}>
                        {process.env.REACT_APP_VERSION}
                    </div>
                </Drawer>
                <main
                    className={
                        isMobileView
                            ? classes.contentMobile
                            : clsx(classes.content, {
                                  [classes.contentShift]: open,
                              })
                    }
                    style={{ height: '100%' }}
                >
                    <div className={classes.drawerHeader} />
                    <Grid container className={classes.containerBody} id="root-view">
                        {children}
                    </Grid>
                </main>
            </div>
        </>
    )
}

const Layout: React.FC<LayoutViewProps> = ({ children }) => {
    const history = useHistory()
    const layout = useLayout({})
    const authenService = useAuthenService()
    const autAction = authenAction()
    React.useEffect(() => {
        const checkGetprofile = async () => {
            const accessToken = localStorage.getItem('accessToken')
            const loginType = localStorage.getItem('loginType')
            if (accessToken && loginType) {
                try {
                    const getProfile = await authenService.getProfile(accessToken, loginType as unknown as 1 | 2)
                    autAction.setProfile(getProfile.result)
                } catch (error) {
                    console.error('checkGetprofile failed:', error)
                    localStorage.clear()
                    history.replace(RoutePath.login, null)
                }
            }
            //  else {
            //     history.replace(RoutePath.login, null)
            // }
        }
        checkGetprofile()
    }, [])

    return <LayoutView children={children} {...layout} />
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        height: '100%',
    },
    textPrimary: {
        color: theme.palette.text.primary,
    },
    appBar: {
        backgroundColor: 'white',
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        boxShadow: '0px 0px 5px 0px rgb(0 0 0 / 75%)',
        // overflowY: 'unset'
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        // padding: theme.spacing(7, 1),
        padding: (props: { isShowTab: boolean }) => {
            if (props.isShowTab) {
                return theme.spacing(7, 1)
            } else {
                return theme.spacing(0, 1)
            }
        },
        [theme.breakpoints.down('md')]: {
            minHeight: '64px',
        },
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        // padding: theme.spacing(3),
        // paddingTop: theme.spacing(10),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
        height: 'calc(100% - 110px)',
        zIndex: 0,
        backgroundColor: 'inherit',
        width: '100%',
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
    contentMobile: {
        padding: theme.spacing(3),
        width: '100%',
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(1),
        },
    },
    listRoot: {
        paddingBottom: 0,
        paddingTop: 0,
    },
    selectedMenu: {
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
    },
    menuText: {
        fontSize: '14px ',
    },
    iconListRoot: {
        minWidth: '40px',
    },
    iconListSelectedRoot: {
        color: theme.palette.primary.main,
    },
    containerBody: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '0px',
            paddingRight: '0px',
        },
        // height: 'calc(100% - 70px)',
        // overflowY: 'auto'
    },
    itemRole: {
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
}))

export default Layout
